import React from 'react';
import {Backdrop} from 'material-ui';

export const BackDropCMS = (props) => {
    return (
        <Backdrop style={{backgroundColor: 'rgba(0, 0, 0, 0.9)'}} {...props} />
    )
}


// WEBPACK FOOTER //
// ./src/components/backdrop/backdrop_cms.js